import React, { useRef, useEffect, useLayoutEffect } from 'react';
import styled from 'styled-components';

// hooks
import useScreenSize from 'hooks/useScreenSize';

const Canvas = styled.canvas`
  z-index: 10;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const Wave = () => {
  const screenDimensions = useScreenSize();

  const canvasRef = useRef();
  const animationFrameRef = useRef();
  const ctxRef = useRef({});

  let step = -4;

  useEffect(() => {
    if (screenDimensions.screenWidth > 0) {
      canvasRef.current.width = screenDimensions.screenWidth;
    }
  }, [screenDimensions]);

  useLayoutEffect(() => () => cancelAnimationFrame(animationFrameRef.current), []);

  const drawWave = (amplitude, trig, color) => {
    const { ctx } = ctxRef.current;
    const { width, height } = canvasRef.current;
    ctx.strokeStyle = color;

    ctx.beginPath();

    let x = 0;
    let y = 0;

    step += 1;

    const frequency = height / (2 * Math.PI);

    ctx.save();
    ctx.translate(-amplitude * Math[trig](step / frequency), 0);
    while (x < width) {
      y = height / 2 + amplitude * Math[trig]((x + step) / frequency);
      ctx.lineTo(x, y);
      // eslint-disable-next-line no-plusplus
      x++;
    }

    ctx.stroke();
    ctx.restore();
  };

  const initDrawWave = () => {
    const { width, height } = canvasRef.current;
    const { ctx } = ctxRef.current;
    ctx.clearRect(0, 0, width, height);
    ctx.setLineDash([3, 7]);
    drawWave(20, 'cos', 'rgba(255, 255, 255, 1)');
    drawWave(15, 'sin', 'rgba(221, 34, 104, 1)');
    drawWave(40, 'cos', 'rgba(0, 111, 155, 1)');
    step += 1;
    animationFrameRef.current = requestAnimationFrame(initDrawWave);
  };

  useEffect(() => {
    canvasRef.current.height = 500;
    ctxRef.current.ctx = canvasRef.current.getContext('2d');
    ctxRef.current.ctx.lineWidth = 1;
    initDrawWave();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Canvas ref={canvasRef} />;
};

export default Wave;
